import Favorite from './views/Favorite.vue'

const route = [
  {
    path: '/mes-favoris',
    name: 'favorite',
    component: Favorite,
    meta: {
      layout: 'default',
      auth: true,
      menu: false,
      title: 'Mes favoris',
      lang_code: "my_favourites",
      role: ['A']
    }
  }
]

export default route